import { render, staticRenderFns } from "./PrettyDateTime.vue?vue&type=template&id=3657ff5f&"
import script from "./PrettyDateTime.vue?vue&type=script&lang=js&"
export * from "./PrettyDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports